document.addEventListener("DOMContentLoaded", function () {
  //   ------------ product Carousels ---------------
  const productCarousels = document.querySelectorAll(".spp-carousel");

  if (productCarousels) {
    productCarousels.forEach((carousel) => {
      const nextButton = carousel.parentElement.querySelector(
        ".swiper-button-next"
      );

      const prevButton = carousel.parentElement.querySelector(
        ".swiper-button-prev"
      );

      const productSelector = carousel.getAttribute("data-product-selector");
      const selectorName = carousel.getAttribute("data-selector-name");
      const form = document.getElementById("subscription-product-picker-form");

      const productGallery = new Swiper(carousel, {
        direction: "horizontal",
        spaceBetween: 8,
        allowTouchMove: true,
        loop: true,
        slidesPerView: 2.5,
        breakpoints: {
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
        },
        on: {
          slideChange: function () {
            const index = this.realIndex;
            const activeSlide = this.slides[this.activeIndex];

            if (productSelector === "true") {
              // Update price
              if (activeSlide) {
                const price = activeSlide
                .querySelector("button")
                .getAttribute("data-price");

              const toUSD = (cents) =>
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(cents / 100);
                const standardPrice = toUSD(price);
                const discountPrice = toUSD(price * 0.9);
                const standardPriceElement = document.querySelector(
                  ".spp-standard-price .money"
                );
                const discountPriceElement = document.querySelector(
                  ".spp-discounted-price .money"
                );
                if (standardPriceElement) {
                  standardPriceElement.innerHTML = standardPrice;
                }
                if (discountPriceElement) {
                  discountPriceElement.innerHTML = discountPrice;
                }
              }

              // Update input value on change like on btn click
              // even remove button click becasue it updates the slide
              const currActiveDescription = document.querySelector(
                ".product-description:not(.hidden)"
              );
              const currActiveMainCarousel = document.querySelector(
                ".spp-main-carousel-container:not(.hidden)"
              );

              if (currActiveDescription && currActiveMainCarousel) {
                currActiveDescription.classList.add("hidden");
                currActiveMainCarousel.classList.add("hidden");
              }

              const newActiveDescription = document.querySelector(
                `.product-description[data-product-description="${index + 1}"]`
              );
              const newActiveMainCarousel = document.querySelector(
                `.spp-main-carousel-container[data-main-carousel="${
                  index + 1
                }"]`
              );
              if (newActiveDescription && newActiveMainCarousel) {
                newActiveDescription.classList.remove("hidden");
                newActiveMainCarousel.classList.remove("hidden");
              }
            }

            // On new slide update hidden field with value for form
            if (!activeSlide) return;
            const selectorName = carousel.getAttribute("data-selector-name");

            const variantId =
              activeSlide.firstElementChild.getAttribute("data-variant-id");
            if (!variantId) return;

            const hidden = form.querySelector(`input[name="${selectorName}"]`);
            hidden.value = variantId;
          },
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
      });

      productSelectorBtns = carousel.querySelectorAll(".swiper-slide button");
      productSelectorBtns.forEach((btn, index) => {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          productGallery.slideToLoop(index);
        });
      });
    });
  }

  //   ------------ Main Carousel ---------------
  const mainCarousel = document.querySelectorAll(
    ".spp-main-carousel-container"
  );

  if (mainCarousel) {
    mainCarousel.forEach((carousel) => {
      const mainCarouselEl = carousel.querySelector(".spp-main-carousel");
      const mainCarouselThumbsEl = carousel.querySelector(
        ".spp-main-carousel-thumbs"
      );
      const mainCarouselPagination = carousel.querySelector(
        ".spp-main-carousel-pagination"
      );

      const mainCarouselThumbs = new Swiper(mainCarouselThumbsEl, {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const mainCarousel = new Swiper(mainCarouselEl, {
        spaceBetween: 10,
        thumbs: {
          swiper: mainCarouselThumbs,
        },
        pagination: {
          el: mainCarouselPagination,
        },
      });
    });
  }

  //   ------------ Subscription Toggle ---------------
  const subscriptionToggle = document.getElementById("spp-subscription-toggle");
  const sellingPlan = document.getElementById("spp-selling-plan");
  const subscriptionContent = document.querySelector(
    ".spp-subscription-section .content-area"
  );
  const standardPriceElement = document.querySelector(".spp-standard-price");
  const discountPriceElement = document.querySelector(".spp-discounted-price");

  if (subscriptionToggle && sellingPlan) {
    subscriptionToggle.addEventListener("change", function (event) {
      if (event.target.checked) {
        sellingPlan.removeAttribute("disabled");
        subscriptionContent.classList.remove("disable");
        standardPriceElement.classList.add("line-through");
        discountPriceElement.classList.remove("hidden");
      } else {
        sellingPlan.setAttribute("disabled", "true");
        subscriptionContent.classList.add("disable");
        standardPriceElement.classList.remove("line-through");
        discountPriceElement.classList.add("hidden");
      }
    });
  }

  //  ------------ Form Submission ---------------
  const priceButtons = document.querySelector("#step-4");
  const form = document.getElementById("subscription-product-picker-form");

  const handleScroll = () => {
    const formTop = form.getBoundingClientRect().top;
    const priceButtonsBottom = priceButtons.getBoundingClientRect().bottom;
    const windowHeight = window.innerHeight;

    if (formTop < windowHeight / 2) {
      priceButtons.style.bottom = "20px";
    } else {
      priceButtons.style.bottom = "-140px";
    }

    if (priceButtonsBottom < windowHeight - 20) {
      priceButtons.classList.remove("is-stuck");
    } else {
      priceButtons.classList.add("is-stuck");
    }
  };

  if (priceButtons) {
    window.addEventListener("scroll", handleScroll);
  } else {
    window.removeEventListener("scroll", handleScroll);
  }
});
